import React from "react";
export const SingleBoxContext = React.createContext();

export default function BoxProvider({children}) {
  const [pets, setPets] = React.useState([]);

  function getPetsInBox() {
    return pets;
  }

  function setPetsInBox(pets = []) {
    setPets(pets);
  }

  const values = { getPetsInBox, setPetsInBox };

  return (
    <SingleBoxContext.Provider value={values}>
      {children}
    </SingleBoxContext.Provider>
  );
}
